/** 
 * The CMSBlock component
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Col, Row, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import closeicon from '../../assets/icons/icon-close.svg'

/**
 * CMSBlock component
 * - renders cms content set in the admin panel
 */
const ContentBlockShowMore = (props, context) => {
  const {cmsblock, hideTitle, noImage} = props;
  const [modal, setModal] = useState(false);
  const HeadingTag = 'h' + (props.headinglevel ? props.headinglevel : '2');

  const toggleModal = () => setModal(!modal);
  const closeBtn = 
    <button className="close text-danger" onClick={toggleModal}>
      <img src={closeicon} width="18px" height="18px" alt={context.t("Schließen")}/>
      <span className='sr-only'>{context.t("Schließen")}</span>
    </button>;

  return (
    <Container className="cmsblockmore">
      {cmsblock && <Row>
        <Col xs={12}>
          { cmsblock.title && !hideTitle &&
            <HeadingTag>
              {cmsblock.title}
            </HeadingTag>
          }
          <div className="cmsblockmore__preview" dangerouslySetInnerHTML={{__html: cmsblock.text}} />
          <div className="text-right">
            <Button color="link" onClick={toggleModal}>{context.t("Mehr lesen")}</Button>
          </div>
          {!noImage && cmsblock.image &&
            <img src={cmsblock.image} alt={cmsblock.image_description} className="cmsblock__image"/>
          }
        </Col>
      </Row>}
      { cmsblock && modal && 
        <Modal isOpen={modal} toggle={toggleModal} className={"checklists__hero__modal"} centered>
          <ModalHeader toggle={toggleModal} close={closeBtn} className='checklists__hero__modal__header'>{cmsblock.title}</ModalHeader>
          <ModalBody>
            <div dangerouslySetInnerHTML={{__html: cmsblock.text}} />
          </ModalBody>
        </Modal>
      }
    </Container>
  );
}

/** define proptypes for the form */
ContentBlockShowMore.propTypes = {
  cmsblock: PropTypes.object.isRequired,
};

/**  define proptype for the 'translation' function  */
ContentBlockShowMore.contextTypes = {
  t: PropTypes.func
}
export default ContentBlockShowMore;